export enum Locales {
  ru = 'ru-RU',
  en = 'en-US',
}
